import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import dpImage from '../img/hr-logo.jpg'; 
// import dpImage from '../img/ddchrlogo.png'; 

const Sidennav = ({ refresh }) => {
  const [menus, setMenus] = useState([]);
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [menusLoaded, setMenusLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMenusByRole = async () => {
      try {
        const roleid = localStorage.getItem("roleid");
        const userid = localStorage.getItem("id");
        const accesstoken = localStorage.getItem("token");
        if (!roleid || !userid || !accesstoken) {
          console.warn("Missing credentials in localStorage.");
          return;
        }
        const response = await axios.get(
          `${baseurladdress}fetchprogrambasedonrole/${roleid}/${userid}`,
          {
            headers: { Authorization: `Bearer ${accesstoken}` },
          }
        );
        if (response.data.status === "success") {
          const data = response.data.data;
          const autoIncludeIds = [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52,53];
          // Keep items with pgm_status = 1 OR specific IDs
          const onlyStatusOne = data.filter(
            p => Number(p.pgm_status) == 1 || autoIncludeIds.includes(p.pgm_id)
          );
          const formatted = onlyStatusOne.map(p => ({
            id: p.pgm_id,
            name: p.pgm_menu,
            icon: p.pgm_icon,
            parent: p.pgm_parent,
            url: p.pgm_url,
          }));
          setMenus(formatted);
          setMenusLoaded(true);
        } else {
          console.warn("Menu fetch unsuccessful:", response.data.message || "Unknown error");
          setMenus([]);
          setMenusLoaded(true);
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
        setMenus([]);
        setMenusLoaded(true);
      }
    };


    const fetchURLByRole = async () => {
      try {
        const roleid = localStorage.getItem("roleid");
        const userid = localStorage.getItem("id");
        const accesstoken = localStorage.getItem("token");

        if (!roleid || !userid || !accesstoken) {
          console.warn("Missing credentials in localStorage.");
          return;
        }
        const response = await axios.get(
          `${baseurladdress}fetchurlbasedonrole/${roleid}/${userid}`,
          {
            headers: { Authorization: `Bearer ${accesstoken}` },
          }
        );

        if (response.data.status === "success") {
          const data = response.data.data;
          const autoIncludeIds = [35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 51,52,53];

          // Keep items with pgm_status = 1 OR specific IDs
          const onlyStatusOne = data.filter(
            p => Number(p.pgm_status) == 1 || autoIncludeIds.includes(p.pgm_id)
          );

          const formatted = onlyStatusOne.map(p => ({
            id: p.pgm_id,
            name: p.pgm_menu,
            icon: p.pgm_icon,
            parent: p.pgm_parent,
            url: p.pgm_url,
          }));

          const hasShiftAssignment = data.some(m => m.pgm_id === 14 && m.pgm_status === 1);

          if (hasShiftAssignment) {
            const targetMenu = data.find(
              m => autoIncludeIds.includes(m.pgm_id) && m.pgm_status === 1
            );
            if (targetMenu?.pgm_parent) {
              setExpandedMenu(targetMenu.pgm_parent);
            }

            if (data.some(m => m.pgm_id === 35 && m.pgm_status === 1)) {
              setSelectedMenu(35);
              localStorage.setItem("selectedMenu", 35);
            }
          }

          const saved = localStorage.getItem("selectedMenu");
          if (saved && !autoIncludeIds.includes(Number(saved))) {
            const savedId = parseInt(saved);
            setSelectedMenu(savedId);
            const selectedItem = formatted.find(m => m.id === savedId);
            if (selectedItem?.parent) {
              setExpandedMenu(selectedItem.parent);
            }
          }

          // const currentPath = window.location.pathname.replace(/^\//, "").toLowerCase();
          let allowedUrls = formatted.map(m => m.url?.toLowerCase()).filter(Boolean);
          const pathname = window.location.pathname; // "/editshiftassignment/2" or "/editshiftassignment"
          const segments = pathname.split('/').filter(Boolean); // removes empty strings from leading slashes
          //const currentPath = segments[0].toLowerCase(); // "editshiftassignment"

          const currentPath =
  (segments[0].toLowerCase() === "ddchr"
    ? segments[1]
    : segments[0])?.toLowerCase() || "";

//           console.log("pathname =", window.location.pathname);
// console.log("href =", window.location.href);
// console.log("allowedUrls =", allowedUrls);
// console.log("currentPath =", currentPath);

          if (hasShiftAssignment) {
            const extraMenus = formatted.filter(m => autoIncludeIds.includes(m.id));
            const extraUrls = extraMenus.map(m => m.url?.toLowerCase()).filter(Boolean);
            allowedUrls = [...new Set([...allowedUrls, ...extraUrls])];
          }

          const isAllowed = allowedUrls.includes(currentPath);

          if (!isAllowed && currentPath !== "unauthorized") {
            navigate("/unauthorized");
          }
        } else {
          console.warn("Menu fetch unsuccessful:", response.data.message || "Unknown error");
          setMenus([]);
          setMenusLoaded(true);
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
        setMenus([]);
        setMenusLoaded(true);
      }
    };
    fetchURLByRole();
    fetchMenusByRole();
  }, [refresh]);

  const handleParentClick = (parent) => {
    const hasChildren = menus.some(child => child.parent === parent.id);
    if (hasChildren) {
      setExpandedMenu(expandedMenu === parent.id ? null : parent.id);
    } else if (parent.url) {
      setSelectedMenu(parent.id);
      localStorage.setItem("selectedMenu", parent.id);
      navigate(`/${parent.url}`);
    }
  };

  const handleChildClick = (child) => {
    setSelectedMenu(child.id);
    localStorage.setItem("selectedMenu", child.id);
    setExpandedMenu(child.parent);
    navigate(`/${child.url}`);
  };

  return (
    <div
      className="sidebar sidebar-hide-to-small sidebar-shrink sidebar-gestures"
      style={{ backgroundColor: '#333', padding: '16px', minHeight: '100vh' }}
    >
      <div
        style={{
          display: 'flex',
            justifyContent: 'center',
          alignItems: 'center',
          fontSize: '20px',
          fontWeight: 'bold',
          marginBottom: '20px',
          color: 'white'
        }}
      >
     
         <img
      src={dpImage}
      alt="HR Logo"
      style={{ width: '24px', height: '24px', marginRight: '8px' }}
    />
        DDC HR
      </div>

      <ul style={{ listStyle: 'none', padding: 0 }} id="sidebarr">
        {menus.filter(menu => menu.parent === 0).map(parent => {
          const hasChildren = menus.some(child => child.parent === parent.id);
          const isParentActive =
            selectedMenu === parent.id ||
            menus.some(child => child.parent === parent.id && child.id === selectedMenu);

          return (
            <li
              key={parent.id}
              style={{
                color: isParentActive ? 'grey' : 'white',
                marginBottom: '20px',
                fontSize: '14px'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: hasChildren || parent.url ? 'pointer' : 'default'
                }}
                onClick={() => handleParentClick(parent)}
              >
                <i className={`fa ${parent.icon}`} style={{ marginRight: '12px' }}></i>
                <span>{parent.name}</span>
                {hasChildren && (
                  <i
                    className={`fa fa-angle-${expandedMenu === parent.id ? "up" : "down"}`}
                    style={{ marginLeft: '10px' }}
                  ></i>
                )}
              </div>

              {hasChildren && expandedMenu === parent.id && (
                <ul style={{ listStyle: 'none', paddingLeft: '20px', marginTop: '8px' }}>
                  {menus
                    .filter(child => child.parent === parent.id)
                    .map(child => {
                      const isChildActive = selectedMenu === child.id;
                      return (
                        <li
                          key={child.id}
                          style={{
                            marginBottom: '10px',
                            cursor: 'pointer',
                            color: isChildActive ? 'grey' : 'white',
                            fontSize: '14px'
                          }}
                          onClick={() => handleChildClick(child)}
                        >
                          <i className={`fa ${child.icon}`} style={{ marginRight: '10px' }}></i>
                          <span>{child.name}</span>
                        </li>
                      );
                    })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidennav;


